import { useEffect, useState } from 'react';

const useOnModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [element, setElement] = useState<Element | null>(null);
  const [parentElement, setParentElement] = useState<Element | null>(null);

  const isElementVisible = (element: Element | null): boolean => {
    if (!element || !parentElement) return false;

    const { top: childTop, bottom: childBottom } =
      element.getBoundingClientRect();
    const { top: parentTop, bottom: parentBottom } =
      parentElement.getBoundingClientRect();
    return childTop >= parentTop && childBottom <= parentBottom;
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(isElementVisible(element));
    };
    if (parentElement) {
      parentElement.addEventListener('scroll', handleScroll);
      parentElement.addEventListener('resize', handleScroll);
      handleScroll();
    }

    return () => {
      if (parentElement) {
        parentElement.removeEventListener('scroll', handleScroll);
        parentElement.removeEventListener('resize', handleScroll);
      }
    };
  }, [element, parentElement]);

  return { setElement, setParentElement, isVisible };
};

export default useOnModal;
